function parseHex(color) {
  const match = /^#([\da-f]{3,8})$/i.exec(color)
  if (!match) return null
  let hex = match[1]
  if (hex.length === 3 || hex.length === 4) {
    hex = hex
      .split('')
      .map((c) => c + c)
      .join('')
  }
  const r = parseInt(hex.slice(0, 2), 16)
  const g = parseInt(hex.slice(2, 4), 16)
  const b = parseInt(hex.slice(4, 6), 16)
  return { r, g, b }
}

function parseRgb(color) {
  const match = /^rgba?\(([^)]+)\)$/i.exec(color)
  if (!match) return null
  const parts = match[1].split(',').map((s) => s.trim())
  if (parts.length < 3) return null
  return {
    r: Number(parts[0]),
    g: Number(parts[1]),
    b: Number(parts[2])
  }
}

function clampAlpha(alpha) {
  const value = Number(alpha)
  if (!Number.isFinite(value)) return null
  if (value > 1) return Math.min(value / 100, 1)
  if (value < 0) return 0
  return value
}

export function withAlpha(color, alpha) {
  if (!color) return undefined
  const a = clampAlpha(alpha)
  if (a == null || a === 1) return color

  const rgb = parseHex(color) || parseRgb(color)
  if (!rgb) return color

  return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${a})`
}
